import { textXs } from '@insify/design-system/typography';
import { TrackedAnchor } from '@objectiv/tracker-react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import * as styles from './PrivacyPolicyLink.module.css';

export const PrivacyPolicyLink: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation(['funnel']);

  return (
    <div className={clsx(styles.section, className)}>
      <TrackedAnchor
        className={textXs}
        objectiv={{ id: 'privacy-policy' }}
        href='https://www.insify.fr/politique-de-confidentialite/'
        target='_blank'
        rel='noreferrer'
      >
        {t('funnel:activity_privacy_policy')}
      </TrackedAnchor>
    </div>
  );
};
